module.exports = __webpack_public_path__ + "static/media/undo.faccd1c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/undo.jpg
// module id = 103
// module chunks = 0